import { ErrorBoundaryFallback } from "common/ErrorBoundaryFallback";
import { ErrorBoundary } from "react-error-boundary";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import { AppTrackers } from "./AppTrackers";
import { PermissionNavigate } from "./PermissionNavigate";
import { Shell } from "./Shell";

export const PublicRouter = () => {
  return (
    <Router>
      <>
        <Routes>
          <Route path="" element={<PermissionNavigate />} />
          <Route
            path="/*"
            element={
              <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
                <Shell />
              </ErrorBoundary>
            }
          />
        </Routes>
        <AppTrackers />
      </>
    </Router>
  );
};
